// ng build --prod --aot=false --build-optimizer=false
// firebase deploy
// npm run generate:svg-sprite
// https://admin-board-uat.flexm.com/

import { InstanceName } from 'src/app/utilities/common-file';

export const Config = {
    // DEV
    // merchantId:7,
    // hst:'true',
    // appStarted: 'Jan 01 2020 05:30:00 GMT+0530',
    // appCode : InstanceName.dev,
    // country:  { currency: "CAD", country: "Canada"},
    // baseUrl: 'https://ffp3admin-api-dev.flexm.com',    
    // apiKey : 'JPKVD25-3AM4S44-QGBVGJZ-3J8NHTS',//ADB key    
    // clientPrivateKey: '1ea9e25f61d59d0d4cd56daa3a53a2bd034f6e0eb79c2e3a214d7fef841c7a21',
    // clientPublicKey: '04184619b5245772c8d0126b5f9ee1331a4ad6b8f700b112ef2c3cb3968352cc6f2c4ecb4b4c222c451c6020882f435248300e11101dcc315960cbb45dc1a2d6bc',
    // serverPublicKey: '048f26963af57cc3b22daccec961c844badb78d6bcaa47aeeca9c6dab4cfcf404e54e24b4c25ab02ef5e593ace7b1ee684eaa064c504add1eaf10c0403d7329fed',
    // // apiKey : '7JD14W2-WVZ4DPS-GD76K7W-67AY2XF',//connect key
    // DatabaseConfig: {
    //     apiKey: "AIzaSyBYkyK_njEWi0maN4Y9JhnJPlD6W7zVKPc",
    //     authDomain: "admin-board-1a026.firebaseapp.com",
    //     databaseURL: "https://admin-board-1a026.firebaseio.com",
    //     projectId: "admin-board-1a026",
    //     storageBucket: "admin-board-1a026.appspot.com",
    //     messagingSenderId: "438952667608",
    //     appId: "1:438952667608:web:20575810556b6e66bdaaad",
    //     measurementId: "G-2BCDE0DB1V"
    // }


    // UATPHP
    // merchantId:1,
    // hst:'false',
    // appStarted: 'Jan 01 2020 05:30:00 GMT+0530',
    // appCode : InstanceName.uatPHP,
    // country:  { currency: "CAD", country: "Canada"},
    // baseUrl: 'https://ffp3admin-api-ph-uat.flexm.com',
    // apiKey : 'KWWZ85K-1J34F7S-NE5A8G6-WBF8PWW',
    // clientPrivateKey: '41b06138fef51d05215ee3115c457df80c2d01228e0c930a66273f65749776d6',
    // clientPublicKey: '04e2785a7aa8d2d4f98342c3e5fd50a4b385eb11132ecbdf4d80ed7061addddabcf57f3ddc8942cc9993149f32db94d386046385552f5a7a9feeb0f75dae2ccb77',
    // serverPublicKey: '041634a80dd5d2d50fa6b8f35126e7083fcaa483b029c809f93f3dc9bfc4faee9cea67ae3da157b57dc4c89a3a53430f4e588c1965f62921afbf49bb2d1cc25349',
    //      DatabaseConfig: {
    //     apiKey: "AIzaSyBnta5p1vKLmgysKezRyUoKnQULjzGSji0",
    //     authDomain: "admin-board-phl-uat.firebaseapp.com",
    //     projectId: "admin-board-phl-uat",
    //     storageBucket: "admin-board-phl-uat.appspot.com",
    //     messagingSenderId: "436621403564",
    //     appId: "1:436621403564:web:176e00c7c3061fb5b1c609",
    //     measurementId: "G-Y9ZK0PV0ES"
    // }
    //


    // Flexbiz- TEST

    // hst: 'false',
    // appStarted: 'Jan 01 2020 05:30:00 GMT+0530',
    // merchantId:1,
    // masterMerchantId:1369,
    // appCode : InstanceName.flexBiz,
    // baseUrl: 'https://test-flexbiz.flexm.com',
    // remitUrl: 'https://frsg-admin-uat.flexm.com/api',
    // country:  { currency: "SGD", country: "Singapore"},
    // clientIdRemit: "deeadcac-bcbd-489f-9675-bc496d723942",
    // clientSecretRemit: "761d84ad-46d7-450b-8706-ef3a3a207431",
    // apiKey : '6W657YF-CY347XA-PZ75PB7-3SCG17M',             
    // clientPrivateKey: '2a3abb9cf275973413bb86c57a1fb5ec9316314abcb74de0b6ca0db9e5b9e6a1',
    // clientPublicKey: '04727b12a5514c80e2e98128877de18902948f298307893cc9c0fe26e66b2c0c189ad84bb6cfec41a0bf8bec193d0c839fb55d1e7ccf6ab5214119b79ed712ea34',
    // serverPublicKey: '04202504326fb9e08cce0d106346251d9d6806c9caf665002ee73f191ec716c94de04207064998d0794812ad65efd2dc5e85bae77ba4aeb9a492d0b7222a19c924',
    // DatabaseConfig: {
    //     apiKey: "AIzaSyAtm7675vuiirBEpJDeGIpzrLXY-05IeAo",
    //     authDomain: "flexpay-biz-test.firebaseapp.com",
    //     projectId: "flexpay-biz-test",
    //     storageBucket: "flexpay-biz-test.firebasestorage.app",
    //     messagingSenderId: "423138484955",
    //     appId: "1:423138484955:web:300ea397785dcee0d822fe",
    //     measurementId: "G-0XCP5B79F8",

    //     }

    // Flexbiz- UAT
    // hst: 'false',
    // appStarted: 'Jan 01 2020 05:30:00 GMT+0530',
    // merchantId: 1,
    // masterMerchantId:1369,
    // appCode: InstanceName.flexBiz,
    // country: { currency: "SGD", country: "Singapore" },
    // baseUrl: 'https://uat-flexbiz.flexm.com',
    // remitUrl: 'https://frsg-admin-uat.flexm.com/api',
    // clientIdRemit: "deeadcac-bcbd-489f-9675-bc496d723942",
    // clientSecretRemit: "761d84ad-46d7-450b-8706-ef3a3a207431",
    // merchantOnboardingUrl: 'https://fp-merchant-api-ca-uat.flexm.com',
    // merchantPaymentLink: 'https://phl-uat-merchant-payment-flexm.web.app/pay/',
    // apiKey: '6W657YF-CY347XA-PZ75PB7-3SCG17M',
    // clientPrivateKey: '2a3abb9cf275973413bb86c57a1fb5ec9316314abcb74de0b6ca0db9e5b9e6a1',
    // clientPublicKey: '04727b12a5514c80e2e98128877de18902948f298307893cc9c0fe26e66b2c0c189ad84bb6cfec41a0bf8bec193d0c839fb55d1e7ccf6ab5214119b79ed712ea34',
    // serverPublicKey: '04202504326fb9e08cce0d106346251d9d6806c9caf665002ee73f191ec716c94de04207064998d0794812ad65efd2dc5e85bae77ba4aeb9a492d0b7222a19c924',
    // DatabaseConfig: {
    //     apiKey: "AIzaSyCei7My1whDIdB6-qE7LNnPc1KOItDGMoI",
    //     authDomain: "flexpay-biz-uat.firebaseapp.com",
    //     projectId: "flexpay-biz-uat",
    //     storageBucket: "flexpay-biz-uat.firebasestorage.app",
    //     messagingSenderId: "413075361036",
    //     appId: "1:413075361036:web:911cd0b52c87d9d762cd29",
    //     measurementId: "G-XZVGTXHEF1"
    // }

    // Flexbiz- LIVE
    hst: 'false',
    merchantId: 1,
    appCode: InstanceName.flexBiz,
    masterMerchantId:7,
    appStarted: 'Jan 01 2020 05:30:00 GMT+0530',
    baseUrl: 'https://live-flexbiz.flexm.com',
    remitUrl: 'https://remitsg.flexm.com/api',
    clientIdRemit: "ec009db2-a455-49e8-8d14-5e48d5c7c2c3",
    clientSecretRemit: "6862d7a9-6940-4749-8065-7b65e34f2028",
    merchantOnboardingUrl: 'https://fp-merchant-api-ca-uat.flexm.com',
    merchantPaymentLink: 'https://phl-uat-merchant-payment-flexm.web.app/pay/',
    country: { currency: "SGD", country: "Singapore" },
    apiKey: '6W657YF-CY347XA-PZ75PB7-3SCG17M',
    clientPrivateKey: 'b2bf6c4face714c4f9567ee3dc680e9e267787e0662d2efce15ea30bbaa92055',
    clientPublicKey: '04beb5f84c684982a1d12f4310dca1b5d26265ce95fac0b8e6f504b0641f9ff25789314b12fb4c1c47a0568b5e51c32b8b698f376fc5e1c488f3bc323e8b712949',
    serverPublicKey: '04746d6e02b6731c833d1d77dd94fb82136c8f60881bee1834a04ddf24fc591fe113774e3dfa59ae7a4c7f2694ef7db52ea0a6d4b46d4bbf066347cc7de34f725c',
    DatabaseConfig: {
        apiKey: "AIzaSyC0rKeTmRWvmqJap1vAB_BkjHHV5wql9qU",
        authDomain: "flexpay-biz-live.firebaseapp.com",
        projectId: "flexpay-biz-live",
        storageBucket: "flexpay-biz-live.firebasestorage.app",
        messagingSenderId: "601566800679",
        appId: "1:601566800679:web:39c825386cc767abca9702",
        measurementId: "G-C0TFEFS0SS"
    }

    
    // UATSG
    // merchantId:19,
    // hst:'false',
    // appStarted: 'Jan 01 2020 05:30:00 GMT+0530',
    // appCode : InstanceName.uatSG,
    // country:  { currency: "CAD", country: "Canada"},
    // baseUrl: 'https://ffp3admin-api-uat.flexm.com',
    // apiKey : 'GN03641-K7R4H1C-NKCET7K-CWY7TYN',
    // clientPrivateKey: '3987a78712e61ad3e90c8d9de58997364c873b094ee149f88c5cc4fe99edb10a',
    // clientPublicKey: '04ed8bbc96e524e3caa27789a043983059f47ce4f9857b52e98081430255fa9609c67567c20fac72f6d0f609849391a28f3d45e3c072c5d2b30642bc11ba0f3322',
    // serverPublicKey: '04fa74c67c8abe10c33930608a4fe0df3c0696f069ab7b935bf2b788a00e9350f03b8f23501f6605c7b474230ddac98259332154ac1205c86e8384cb5dbc338d83',
    //  DatabaseConfig: {
    //     apiKey: "AIzaSyArsKTsHIoc5kNCsTCU2fPr7GW7BKtVJQs",
    //     authDomain: "admin-board-uat.firebaseapp.com",
    //     databaseURL: "https://admin-board-uat.firebaseio.com",
    //     projectId: "admin-board-uat",
    //     storageBucket: "admin-board-uat.appspot.com",
    //     messagingSenderId: "125588095849",
    //     appId: "1:125588095849:web:ff54cbcad6635ae0f5f3f8",
    //     measurementId: "G-W3HRY6F3V9"
    // }

    // UATCAD
    // merchantId:1,
    // hst:'true',
    // appCode : InstanceName.uatCAD,
    // country:  { currency: "CAD", country: "Canada"},
    // appStarted: 'Jan 01 2020 05:30:00 GMT+0530',
    // baseUrl: 'https://fp-admin-api-ca-uat.flexm.com',
    // apiKey : '6W657YF-CY347XA-PZ75PB7-3SCG17M',             
    // clientPrivateKey: 'fa2e5f97bf4bc32a457eaf865ce8b3a1b51b9e3fcff7155ae2c2c9536c48b546',
    // clientPublicKey: '04dbfec1978fec083f742492fef1fb3494c461b7e3446f384eb3658920ed1fa538f42d1a31ed6587405a6976b275156de3d5a0e3e9464a4e491b8aa8f6aa0e291e',
    // serverPublicKey: '0467d9225d4ae06d7125346038a85ec23d54302c18a041d808e9c5bfd2caa4a0e559d2c5e1ca6eedc537dc053e06e0e84d3411264517b75d8b216a68c0f86b7c9d',
    // DatabaseConfig: {
    //   apiKey: "AIzaSyC1Oy7zS9EuMtd6Fsa6F1gFClJmYwjXJTY",
    //   authDomain: "flexpay-ca-uat-admin.firebaseapp.com",
    //   projectId: "flexpay-ca-uat-admin",
    //   storageBucket: "flexpay-ca-uat-admin.appspot.com",
    //   messagingSenderId: "121129275350",
    //   appId: "1:121129275350:web:2c24171b6a27d052cb9e77",
    //   measurementId: "G-Z97EKJ7D3P"  
    // } 



    // LIVESG
    // merchantId:2,
    // hst:'false',
    // appCode : InstanceName.liveSG,
    // country:  { currency: "CAD", country: "Canada"},
    // appStarted: 'Jan 01 2020 05:30:00 GMT+0530',
    // baseUrl: 'https://ffp3admin-api-sg.flexm.com',
    // apiKey : 'ZPFNCZJ-M3P4JW8-JDYDJFV-A6N95T6',             
    // clientPrivateKey: '3d6e338fb189643e3180c5a7406648ba2e35008ff1a8c4e7e1f08fdc183d7436',
    // clientPublicKey: '045c84aa02b6f2b95265fbf0942ff3f9d2e6be295b71584accbcf5dc3a416aa16aa36dd9921c2c6dd4088897b17ced7ffe7a1a901c2dca7a48352be19da3435def',
    // serverPublicKey: '0408a6c2ac7a55824ee723bee6a06940c4e3358d2c3d38aeff282e1d710e84ef25fb69ead8aec7d4b9d2489166721ea505b65879008c5f45e0dd1a4b34fd045ea1',
    // DatabaseConfig: {
    //     apiKey: "AIzaSyC9xu4652x7d7Vnkx_qPnMWBDA9VjzA7-Q",
    //     authDomain: "admin-board-v3.firebaseapp.com",
    //     projectId: "admin-board-v3",
    //     storageBucket: "admin-board-v3.appspot.com",
    //     messagingSenderId: "842748937961",
    //     appId: "1:842748937961:web:353c21dceebcdaad68d278",
    //     measurementId: "G-2K0V0PRDJJ"
    // }

    // LIVEPHP
    // merchantId:19,
    // hst:'false',
    // appCode : InstanceName.livePHP,
    // country:  { currency: "CAD", country: "Canada"},
    // appStarted: 'Jan 01 2020 05:30:00 GMT+0530',
    // baseUrl: 'https://ffp3admin-api-ph.flexm.com',
    // apiKey : '6W657YF-CY347XA-PZ75PB7-3SCG17M',             
    // clientPrivateKey: '7bc7566c69b400a60958f6591f8e29c09e10cc04ff18344895bc14c8f8165dd3',
    // clientPublicKey: '0480ff20e44c35d7db863cd0acbd9b612497bb0279c0b35765207afc49781d157db00be6f80a03986e4ae4e0562eaef692e26decc8602b97c62b16924164d13e66',
    // serverPublicKey: '041768febaa75f86227d0282adc1884fe76a78e28bbfbb601daa82602d720469f73d130d6a4a90993a189bd35db4020397055fd0b0eb4210f50a54416f4514b87f',
    // DatabaseConfig: {
    //     apiKey: "AIzaSyDIRhSqm1Fxl-REjp1IXJNM9JHTQ2FYYBM",
    //     authDomain: "admin-board3-ph-live-4953d.firebaseapp.com",
    //     projectId: "admin-board3-ph-live-4953d",
    //     storageBucket: "admin-board3-ph-live-4953d.appspot.com",
    //     messagingSenderId: "92660637910",
    //     appId: "1:92660637910:web:d7bb6eefcb84d435156977",
    //     measurementId: "G-WMMV6EJQK4"
    // } 



    // LIVECAD
    // merchantId:19,//Needs to config once Flexm Merchant created
    // hst:'true',
    // appCode : InstanceName.liveCAD,
    // country:  { currency: "CAD", country: "Canada"},
    // appStarted: 'Jan 01 2020 05:30:00 GMT+0530',
    // baseUrl: 'https://fp-admin-api-ca-live.flexm.com',
    // apiKey : '6W657YF-CY347XA-PZ75PB7-3SCG17M',             
    // clientPrivateKey: '0e42646c5e9eb0a2d1c59bcc4f553d9f233d3bf7014bbb6b63201d562116b9c2',
    // clientPublicKey: '04bbbd738dd684eb5bc8ff11a8253725ce5326a2fd90ad1c282e12602d83b44cc3812e62bbc654e70ac7928ef53c17e5951e10a8ea8d8b58b41c7006bf0ff0af6c',
    // serverPublicKey: '04654e36aef3a636b1081c7db97d5e47ac63250a9c5d7c137261414a7a27171567ce2ebd285d3ee2257d59eb5d89a5d981b2f6ec7581838a18575094abf9ecb106',
    // DatabaseConfig: {
    //   apiKey: "AIzaSyA9zs7mRo7hc2QCjIqzUWkfAuIZB_YgLn0",
    //   authDomain: "flexpay-canada-live-admin.firebaseapp.com",
    //   projectId: "flexpay-canada-live-admin",
    //   storageBucket: "flexpay-canada-live-admin.appspot.com",
    //   messagingSenderId: "231904622344",
    //   appId: "1:231904622344:web:3c99acac2283680e69debd",
    //   measurementId: "G-PBY60D3CQP"
    // } 
};

// triggered rebuild
